import React from 'react'

export function GameLanding() {
  return (
    <div className="game-landing-jumbo">

    </div>
  )
}
